module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/b2c8a491128c255f29d437f677e65009.svg";